<button class="file-downloader" (click)="downloadFile()">
  <img
    src="assets/icons/pdf-icon.png"
    alt="icon pdf"
    width="24"
    height="24"
  >
  <span class="file-link text-blue-600 text-body">
    {{ fileName }}.pdf
  </span>
</button>
